/**
 * Curated Lucide subset for brand sidebar icons.
 * Keep in sync with Brand::ICON_KEYS (Ruby). Full Lucide catalog can expand later.
 */
export const BRAND_ICON_KEYS = [
  "archive",
  "badge-check",
  "bell",
  "book-open",
  "bookmark",
  "box",
  "boxes",
  "briefcase",
  "brush",
  "building-2",
  "calendar",
  "camera",
  "car",
  "cat",
  "coffee",
  "compass",
  "crown",
  "diamond",
  "dog",
  "droplet",
  "factory",
  "flag",
  "flame",
  "flower-2",
  "folder",
  "gem",
  "gift",
  "globe",
  "hammer",
  "hash",
  "headphones",
  "heart",
  "house",
  "image",
  "landmark",
  "laptop",
  "layers",
  "leaf",
  "link",
  "mail",
  "map-pin",
  "medal",
  "message-circle",
  "mic",
  "monitor",
  "moon",
  "mountain",
  "music",
  "newspaper",
  "package",
  "palette",
  "pen-tool",
  "phone",
  "plane",
  "scissors",
  "settings",
  "ship",
  "shopping-bag",
  "smartphone",
  "sparkles",
  "star",
  "store",
  "sun",
  "tag",
  "tags",
  "target",
  "trees",
  "trophy",
  "tv",
  "umbrella",
  "utensils",
  "users",
  "video",
  "wine",
  "wrench",
  "zap",
] as const;

export type BrandIconKey = (typeof BRAND_ICON_KEYS)[number];

export const BRAND_COLOR_SWATCHES = [
  "#64748B",
  "#0F766E",
  "#0369A1",
  "#4F46E5",
  "#7C3AED",
  "#DB2777",
  "#DC2626",
  "#EA580C",
  "#CA8A04",
  "#16A34A",
] as const;

const FALLBACK_PALETTE = [
  "#0F766E",
  "#0369A1",
  "#4F46E5",
  "#7C3AED",
  "#DB2777",
  "#EA580C",
  "#CA8A04",
  "#16A34A",
] as const;

export function isBrandIconKey(value: string | null | undefined): value is BrandIconKey {
  return Boolean(value && (BRAND_ICON_KEYS as readonly string[]).includes(value));
}

export function brandFirstChar(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "?";
  return Array.from(trimmed)[0] ?? "?";
}

/** Stable soft color when user has not set `color`. */
export function brandFallbackColor(name: string): string {
  let hash = 0;
  for (const char of name) {
    hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  }
  return FALLBACK_PALETTE[hash % FALLBACK_PALETTE.length] ?? FALLBACK_PALETTE[0];
}

export function normalizeBrandColor(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (!/^#[0-9A-Fa-f]{6}$/.test(trimmed)) return null;
  return trimmed.toUpperCase();
}
